module.exports = __webpack_public_path__ + "static/media/magnifying-glass.a88112de.svg";